import { Box } from "@compass/core";
import { ReactNode } from "react";

interface AuthPageWrapperProps {
    children: ReactNode;
}

export const AuthPageWrapper = ({ children }: AuthPageWrapperProps) => (
    <Box
        sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            py: 2,
        }}
    >
        {children}
    </Box>
);